import React from "react";
import { useRouteError } from "react-router-dom";
//
import { CustomBox } from "./style";

function ErrorBoundary() {
  const error = useRouteError();

  console.error(error);

  return (
    <CustomBox id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </CustomBox>
  );
}

export default ErrorBoundary;
